import { displayDevicesOptions } from '@helpers/utils.js';

const backgroundGradientOptionsAttributes = {
  gradientColorOne: '',
  gradientColorTwo: '',
  gradientDirection: 90,
  gradientColorOneLocation: 0,
  gradientColorTwoLocation: 100,
};
const imageAsBackgroundAttributes = {
  url: '',
  alt: '',
};

const backgroundColorOptionsAttributes = {
  backgroundColor: '',
};

const backgroundImageOptionsAttributes = {
  sectionImgId: '',
  sectionImgUrl: '',
  sectionImgAlt: '',
};

const backgroundVideoAttributes = {
  video: {
    source: '',
    fileName: '',
    showControls: false,
    autoPlay: false,
    loop: false,
    mute: false,
  },
  mobileImage: {
    url: '',
    alt: '',
  },
};

export const attributeBackgroundTypes = {
  backgroundType: {
    type: 'string',
    default: '',
  },
  backgroundGradientOptions: {
    type: 'object',
    default: displayDevicesOptions(backgroundGradientOptionsAttributes),
  },
  backgroundColorOptions: {
    type: 'object',
    default: displayDevicesOptions(backgroundColorOptionsAttributes),
  },
  backgroundImageOptions: {
    type: 'object',
    default: displayDevicesOptions({
      ...backgroundImageOptionsAttributes,
    }),
  },
  backgroundImageAndColorOptions: {
    type: 'object',
    default: displayDevicesOptions({
      ...backgroundColorOptionsAttributes,
      ...imageAsBackgroundAttributes,
    }),
  },
  imageAsBackgroundOptions: {
    type: 'object',
    default: displayDevicesOptions({
      ...imageAsBackgroundAttributes,
    }),
  },
  imageGradientBackgroundOptions: {
    type: 'object',
    default: displayDevicesOptions({
      ...backgroundGradientOptionsAttributes,
      ...imageAsBackgroundAttributes,
    }),
  },
  backgroundVideoOptions: {
    type: 'object',
    default: backgroundVideoAttributes,
  },
  printBackgroundStyles: {
    type: 'boolean',
    default: false,
  },
};
